<template>
    <section class="app-main">
        <router-view></router-view>
    </section>
</template>

<script>
    export default {
        name: 'AppMain',
        computed: {
            // key() {
            //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
            // }
        }
    }
</script>

<style>
    .app-main {
        /*50 = navbar  */
        /* max-width: 1320px; */
        margin: 0 auto;
        font-size: 16px;
        /*min-height: calc(100vh - 342px);*/
        min-height: 100vh;
        height: 100%;
        position: relative;
        background-color: #fff;
        /*background-color: #f5f7fb;overflow: hidden;*/
    }

    @media screen and (max-width: 1200px) {
        .app-main {
            /* padding: 0 20px; */
            box-sizing: border-box;
        }
    }

    @media screen and (max-width: 750px) {
        .app-main {
            background-color: #fff;
            min-height: calc(100vh - 0.9rem);
        }
    }

</style>

